import { useState } from 'react';

export interface FaqItem {
  question: string;
  answer: string;
}

interface FaqAccordionProps {
  items: FaqItem[];
  variant?: 'light' | 'dark';
  defaultOpen?: number | null;
}

export default function FaqAccordion({ items, variant = 'light', defaultOpen = 0 }: FaqAccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(defaultOpen);
  const isDark = variant === 'dark';

  return (
    <div className={`divide-y ${isDark ? 'divide-white/10' : 'divide-cream-200'}`}>
      {items.map((item, idx) => {
        const isOpen = openIndex === idx;

        return (
          <div key={item.question}>
            <button
              type="button"
              onClick={() => setOpenIndex(isOpen ? null : idx)}
              aria-expanded={isOpen}
              className="w-full flex items-start justify-between gap-4 py-4 text-left cursor-pointer group"
            >
              <span
                className={`text-sm font-semibold leading-snug transition-colors duration-300 ${
                  isDark ? 'text-white group-hover:text-gold-300' : 'text-navy-900 group-hover:text-gold-600'
                }`}
              >
                {item.question}
              </span>
              <span
                className={`w-6 h-6 flex items-center justify-center rounded-full shrink-0 mt-0.5 transition-all duration-300 ${
                  isDark ? 'bg-white/10 text-cream-200' : 'bg-gold-50 text-gold-600'
                } ${isOpen ? 'rotate-45' : 'rotate-0'}`}
              >
                <i className="ri-add-line text-sm"></i>
              </span>
            </button>
            <div
              className={`overflow-hidden transition-all duration-500 ease-out ${
                isOpen ? 'max-h-[420px] opacity-100' : 'max-h-0 opacity-0'
              }`}
            >
              <p
                className={`pb-5 pr-8 text-sm leading-relaxed ${
                  isDark ? 'text-cream-300' : 'text-navy-600'
                }`}
              >
                {item.answer}
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
}